import { render, staticRenderFns } from "./ElementsQuestionSlider.vue?vue&type=template&id=dda459c4"
import script from "./ElementsQuestionSlider.vue?vue&type=script&lang=js"
export * from "./ElementsQuestionSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports